const CustomCheckbox = class CustomCheckbox {
    constructor(config) {
        this.jsRadio = config.jsRadio;
        this.jsRadioTrigger = config.jsRadioTrigger;
        this.jsCheckbox = config.jsCheckbox;
        this.jsCheckTrigger = config.jsCheckTrigger;
    }

    init() {
        const checkBox = this.jsCheckbox,
              radio = this.jsRadio;

        if($(this.jsCheckbox).length){
            this.jsCheckTrigger.on("click", function () {
                const trigger = $(this),
                    label = trigger.find('label'),
                    check = trigger.find(checkBox);
                let dataStatus = trigger.attr("data-status");
    
                "off" === dataStatus ? (trigger.attr("data-status", "on"), $(label).addClass('is-active'), $(check).prop('checked', true)) :
                    (trigger.attr("data-status", "off"), $(label).removeClass('is-active'), $(check).prop('checked', false));
            });
        }

        if($(this.jsRadio).length){
            this.jsRadioTrigger.on("click", function () {
                const trigger = $(this),
                    label = trigger.find('label'),
                    check = trigger.find(radio),
                    allLabel = trigger.parent().find('label');

                allLabel.removeClass('is-active');
                label.addClass('is-active');
                check.prop('checked', true);
            });
        }
    }
};

export {CustomCheckbox};


// WEBPACK FOOTER //
// ./static/js/components/CustomCheckbox.js